import React from 'react';
import { Link } from 'react-router-dom';
import { BackButton } from '../../components/ui';

const CommunityContentPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white shadow rounded-lg p-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">Community & Content Policy</h1>
            <BackButton
              onClick={() => window.history.back()}
              variant="link"
              size="small"
              color="#C97B53"
              ariaLabel="Back to Legal Center"
            />
          </div>

          <div className="prose max-w-none">
            <div className="mb-6">
              <p className="text-sm text-gray-500 mb-4">
                Effective Date: [Insert Date]
              </p>
              <p className="text-gray-700 mb-6">
                Vesta is a place for food creators, chefs, and eaters to connect. We encourage creativity, transparency, and respect. This policy sets the rules for content posted on Vesta, including product listings, videos, images, descriptions, and any buyer-seller communications.
              </p>
              <p className="text-gray-700 mb-6">
                By using Vesta, you agree to follow these guidelines.
              </p>
            </div>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Respectful & Safe Community</h2>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li className="mb-2">Treat all members with courtesy and professionalism.</li>
              <li className="mb-2">Harassment, threats, hate speech, or discriminatory language are strictly prohibited.</li>
              <li className="mb-2">Personal disputes should be handled privately — not in public listings, reviews, or comments.</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Content Standards for Sellers</h2>
            <p className="text-gray-700 mb-4">All videos, images, and descriptions must:</p>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li className="mb-2">Accurately represent the product or service being offered.</li>
              <li className="mb-2">Be original or used with permission (no copyright infringement).</li>
              <li className="mb-2">Avoid misleading or exaggerated claims (e.g., "organic" when not certified).</li>
              <li className="mb-2">Include accurate allergen, ingredient, and portion information.</li>
              <li className="mb-2">Reflect safe and sanitary food handling practices.</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Video & Photo Guidelines</h2>
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Quality</h3>
            <p className="text-gray-700 mb-4">
              Use clear, well-lit images and videos that show the actual product or service.
            </p>

            <h3 className="text-lg font-semibold text-gray-900 mb-3">Authenticity</h3>
            <p className="text-gray-700 mb-4">
              Stock photos or videos are not allowed unless clearly marked and used only as supplemental imagery.
            </p>

            <h3 className="text-lg font-semibold text-gray-900 mb-3">Appropriateness</h3>
            <p className="text-gray-700 mb-4">
              Content must not contain nudity, sexually suggestive material, excessive profanity, or graphic depictions of harm.
            </p>

            <h3 className="text-lg font-semibold text-gray-900 mb-3">Food Safety Visuals</h3>
            <p className="text-gray-700 mb-6">
              Avoid showing unsafe food practices (e.g., cross-contamination, improper storage).
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Prohibited Content</h2>
            <p className="text-gray-700 mb-4">You may not post content that:</p>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li className="mb-2">Promotes illegal activities, drugs, or unsafe food production.</li>
              <li className="mb-2">Depicts or encourages violence, abuse, or self-harm.</li>
              <li className="mb-2">Includes personally identifiable information (addresses, phone numbers) without consent.</li>
              <li className="mb-2">Contains spam, scams, or fraudulent offers.</li>
              <li className="mb-2">Uses another person's likeness without their permission.</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Buyer Content & Reviews</h2>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li className="mb-2">Reviews must reflect actual experiences with the seller's products or services.</li>
              <li className="mb-2">False, retaliatory, or misleading reviews are prohibited.</li>
              <li className="mb-2">Buyers may not post photos or videos of other individuals without consent.</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Comments & Messaging</h2>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li className="mb-2">Messaging is for order coordination and professional conversation.</li>
              <li className="mb-2">Offensive, explicit, or unrelated messages are not permitted.</li>
              <li className="mb-2">Soliciting members to transact outside of Vesta is prohibited.</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Moderation & Enforcement</h2>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li className="mb-2">Vesta reserves the right to remove content that violates this policy.</li>
              <li className="mb-2">Repeated or severe violations may result in account suspension or permanent removal.</li>
              <li className="mb-2">Content removed for violations may not be reposted without modification and Vesta approval.</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Reporting Violations</h2>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li className="mb-2">Members can report inappropriate content or behavior via the "Report" feature.</li>
              <li className="mb-2">Reports will be reviewed and acted on within a reasonable timeframe.</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Appeals</h2>
            <p className="text-gray-700 mb-4">If you believe your content was removed in error:</p>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li className="mb-2">Submit an appeal within 7 days of removal.</li>
              <li className="mb-2">Include relevant details and supporting evidence.</li>
              <li className="mb-2">Vesta's decision after appeal is final.</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">10. Content Guidelines Summary</h2>
            <div className="bg-blue-50 p-4 rounded-lg mb-6">
              <h3 className="text-lg font-semibold text-blue-900 mb-3">✅ What's Allowed:</h3>
              <ul className="list-disc pl-6 text-blue-800">
                <li className="mb-1">High-quality, authentic food photos and videos</li>
                <li className="mb-1">Accurate product descriptions and pricing</li>
                <li className="mb-1">Professional, respectful communication</li>
                <li className="mb-1">Honest reviews based on actual experiences</li>
              </ul>
            </div>

            <div className="bg-red-50 p-4 rounded-lg mb-6">
              <h3 className="text-lg font-semibold text-red-900 mb-3">❌ What's Not Allowed:</h3>
              <ul className="list-disc pl-6 text-red-800">
                <li className="mb-1">Stock photos or misleading imagery</li>
                <li className="mb-1">Harassment or discriminatory content</li>
                <li className="mb-1">False claims or fraudulent offers</li>
                <li className="mb-1">Inappropriate or offensive material</li>
              </ul>
            </div>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">11. Contact Information</h2>
            <div className="bg-gray-50 p-4 rounded-lg mb-6">
              <p className="text-gray-700">
                For questions about this policy or to report violations:<br />
                <strong>Email:</strong> content@vesta.com<br />
                <strong>Support Hours:</strong> Daily, 9 AM - 9 PM EST
              </p>
            </div>

            <div className="mt-8 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-500">
                Last updated: {new Date().toLocaleDateString()}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommunityContentPolicy; 